import * as React from 'react';

import { ClosestGeo } from '../../components/RedesignedRecommendationOfferDesktop/ClosestGeo';
import { ECategory, IGeoMobSiteSchema, TClosestGeo } from '../../types/recommendation';
import { getOfferType, isSuburban } from '../../utils/getOfferType';

type TRedesignedGeoInformationContainerProps = {
  category: ECategory;
  geo: IGeoMobSiteSchema;
  regionId?: number;
};

function getUndergroundClosestGeo(geo: IGeoMobSiteSchema): TClosestGeo | null {
  const underground = geo.undergrounds[0];

  if (!underground) {
    return null;
  }

  return {
    type: 'underground',
    name: underground.name,
    time: underground.time,
    transportType: underground.transportType,
    lineColor: underground.lineColor,
  };
}

function getHighwayClosestGeo(geo: IGeoMobSiteSchema): TClosestGeo | null {
  const highway = geo.highways[0];

  if (!highway) {
    return null;
  }

  return {
    type: 'highway',
    name: highway.name,
    distance: highway.distance,
  };
}

function getRailwayClosestGeo(geo: IGeoMobSiteSchema): TClosestGeo | null {
  const railway = geo.railways?.[0];

  if (!railway) {
    return null;
  }

  return {
    type: 'railway',
    name: railway.name,
    time: railway.time,
    travelType: railway.travelType,
    distance: railway.distance,
  };
}

function getClosestGeoFallback(category: ECategory, geo: IGeoMobSiteSchema): TClosestGeo | null {
  const isSuburbanOffer = isSuburban(getOfferType(category));

  if (!isSuburbanOffer) {
    return getUndergroundClosestGeo(geo) || getHighwayClosestGeo(geo);
  }

  return getHighwayClosestGeo(geo) || getUndergroundClosestGeo(geo) || getRailwayClosestGeo(geo);
}

export const RedesignedGeoInformationContainer: React.FC<TRedesignedGeoInformationContainerProps> = ({
  category,
  geo,
  regionId,
}) => {
  const closestGeo = getClosestGeoFallback(category, geo);

  if (!closestGeo) {
    return null;
  }

  return <ClosestGeo closestGeo={closestGeo} regionId={regionId || geo.regionId} />;
};
